'use strict';

import AxiosURLSearchParams from '../../../helpers/AxiosURLSearchParams.js';
export default typeof URLSearchParams !== 'undefined' ? URLSearchParams : AxiosURLSearchParams;



// WEBPACK FOOTER //
// ../lib/platform/browser/classes/URLSearchParams.js